import { render, staticRenderFns } from "./Modernisierung.vue?vue&type=template&id=65034eec&scoped=true&"
import script from "./Modernisierung.vue?vue&type=script&lang=js&"
export * from "./Modernisierung.vue?vue&type=script&lang=js&"
import style0 from "./Modernisierung.vue?vue&type=style&index=0&id=65034eec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65034eec",
  null
  
)

export default component.exports